import { Button, Col, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";

const AdminCreatePaymentHistoryModal = ({
    isModalOpen = false,
    setIsModalOpen = () => { }
}) => {
    const { t } = useTranslation();
    const [form] = useForm();

    return (
        <Modal
            title={t("response_company.label.add_payment_history")}
            open={isModalOpen}
            footer={null}
            maskClosable={false}
            closable={false}
            width={"50vw"}
        >
            <FormAntd
                form={form}
            // onFinish={handleSearch}
            >
                <FormItem shouldUpdate={(prev, curv) => {
                    return false
                }}>
                    {({ getFieldValue, setFieldValue, resetFields }) => {
                        return (
                            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                                <Flex vertical gap={16}>
                                    <Row gutter={24} style={{ marginLeft: "0px" }}>
                                        <Col span={12}>
                                            <FormDatePicker
                                                name="paymentDate"
                                                label={t("response_company.label.payment_date")}
                                                size="large"
                                            />
                                        </Col>

                                    </Row>
                                    <Row gutter={24} style={{ marginLeft: "0px" }}>
                                        <Col span={12}>
                                            <FormSelect
                                                name="packageDetail"
                                                label={t("response_company.label.package_detail")}
                                                size="large"
                                            // options={}
                                            />
                                        </Col>
                                        <Col span={12}>
                                            <FormSelect
                                                name="packageType"
                                                label={t("response_company.label.package_type")}
                                                size="large"
                                            />
                                        </Col>

                                    </Row>
                                    <Row gutter={24} style={{ marginLeft: "0px" }}>
                                        <Col span={12}>
                                            <FormInput
                                                name="pricePaid"
                                                label={t("response_company.label.price_paid")}
                                                size="large"
                                            />
                                        </Col>
                                        <Col span={12}>
                                            <FormSelect
                                                name="paymentMethod"
                                                label={t("employee.salary.label.payment_methods")}
                                                size="large"
                                            />
                                        </Col>
                                    </Row>
                                    <Row gutter={24} style={{ marginLeft: "0px" }}>

                                        <Col span={12}>
                                            <FormDatePicker
                                                name="startDate"
                                                label={t("response_company.label.startDate")}
                                                size="large"
                                            />
                                        </Col>
                                        <Col span={12}>
                                            <FormDatePicker
                                                name="endDate"
                                                label={t("response_company.label.end_date")}
                                                size="large"
                                            />
                                        </Col>
                                    </Row>

                                </Flex>
                                <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                    <Button
                                        type="default"
                                        onClick={() => {
                                            resetFields()
                                            setIsModalOpen(false)
                                        }}
                                        style={{ borderRadius: "8px" }} size="large"
                                    >
                                        {t("common.cancel").toUpperCase()}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                        size="large"
                                    >
                                        {t("common.save").toUpperCase()}
                                    </Button>
                                </Row>
                            </Space>
                        )
                    }}
                </FormItem>
            </FormAntd>
        </Modal>
    )
}

export default AdminCreatePaymentHistoryModal;